import { jsx as _jsx } from "react/jsx-runtime";
const CustomInstructionsHeader = () => {
    return (_jsx("div", { className: "px-3 py-3 border-b border-gray-300 bg-white flex items-center", children: _jsx("h2", { className: "text-xl font-bold text-gray-900 m-0", children: "Custom Instructions" }) }));
};
export default CustomInstructionsHeader;
